import format from 'date-fns/format';
import { Birthdate } from '../entities/Birthdate';
import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';

const getBirthdate = (dateString: Maybe<string>): Birthdate => {
    if (!dateString) {
        return {
            day: '',
            month: '',
            year: '',
        };
    }
    const date = new Date(dateString);

    return { day: format(date, 'dd'), month: format(date, 'MM'), year: format(date, 'yyyy') };
};

export default getBirthdate;
